{
  "version": 1,
  "asset_id": "8fcec9d8-50ce-4695-abd5-751f8b4d141a",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/8fcec9d8-50ce-4695-abd5-751f8b4d141a/antiquing-applied-poster.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/8fcec9d8-50ce-4695-abd5-751f8b4d141a/antiquing-applied-poster.webp",
  "original_filename": "antiquing-applied-poster.webp",
  "size": 221742,
  "content_type": "image/webp",
  "created_at": "2026-09-11T23:20:29Z"
}
